// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"5710b994","269":"e5bff718","448":"cb2380c5","915":"92e18dd4"}[chunkId] + ".chunk.js";
};